module.exports = __webpack_public_path__ + "static/media/9DESA20.a6af5782.jpg";